module.exports = __webpack_public_path__ + "media/images/shop/logo-roche-f4085b0cc7fae58209ab6a7b6f95cd83.png";